import homeUrl from './homeUrl';

/*
 * The booking page for this request, like ProfetBookingLinks::getUrl() in
 * PHP: the campaign booking page on the campaign host, /boka-tid/ on the
 * canonical host. activityId adds ?activity_id= when given.
 */
export default function bookingUrl(activityId) {
	var base = (window.profetWPVars && window.profetWPVars.bookingUrl) || homeUrl('/boka-tid/');

	if (activityId == null || activityId === '') {
		return base;
	}

	return base + (base.indexOf('?') === -1 ? '?' : '&') + 'activity_id=' + encodeURIComponent(activityId);
}
